{
  "dss": {
    "button": {
      "back": "Zpět",
      "cancel": "Storno",
      "close": "Zavřít",
      "confirmDelete": "Ano, smazat",
      "continue": "Pokračovat",
      "logout": "Odhlásit se",
      "passwordReset": "Reset hesla",
      "save": "Uložit",
      "verify": "Ověřit"
    },
    "error": {
      "403": "K této stránce nemáte přístup.",
      "404": "Tato stránka neexistuje.",
      "generic": "Došlo k chybě. Zkuste to prosím znovu později.",
      "invalidConfirmationLink": "Potvrzovací odkaz vypršel nebo je jinak neplatný.",
      "throttling": "Příliš mnoho pokusů. Tato operace je na chvíli blokována.",
      "title": "Chyba",
      "title403": "Přístup odepřen",
      "title404": "Nenalezen"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Privacy Policy",
      "terms": "Terms & Conditions"
    },
    "label": {
      "CRMAccountNumber": "CRM Account Number",
      "contact": "Contact",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "First name",
      "help": "Help",
      "language": "Language",
      "lastname": "Last name",
      "male": "Mr.",
      "newPassword": "Nové heslo",
      "newPassword2": "Opakování nového hesla",
      "oldPassword": "Aktuální heslo",
      "organization": "Organization",
      "password": "Password",
      "required": "required",
      "salutation": "Salutation",
      "select": "Please select"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confirm Registration",
        "wait": "Please wait to complete account confirmation."
      },
      "otp": {
        "btnResend": "Opětovné zaslání ověřovacího kódu e-mailem",
        "msg": {
          "invalidOTP": "Zadané jednorázové heslo je neplatné.",
          "resendFail": "Kód se nepodařilo znovu odeslat. Zkuste to prosím znovu později."
        },
        "spamDetail": "Zkontrolujte si doručenou poštu a složku spamu, zda jste nedostali e-mail od podpory STIHL (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Nedostali jste e-mail?",
        "subtitle": "Abyste mohli pokračovat, musíte ověřit svou e-mailovou adresu.",
        "title": "Ověření uživatelského účtu",
        "txtVerifyMail": "Zadejte prosím ověřovací kód, který jsme vám zaslali na e-mailovou adresu {email}"
      },
      "personal": {
        "msg": {
          "noChange": "There is nothing to update.",
          "updateError": "Failed to update personal data.",
          "updated": "Personal data was updated.",
          "userLoadErr": "Error loading user data. Please try again later."
        },
        "secOrganization": "Organization",
        "secPersonal": "Personal",
        "secSettings": "Preferred Settings",
        "title": "Personal Info"
      },
      "postPwSet": {
        "info": "Nyní můžete používat nové heslo.",
        "link_name": "Continue to Self-Service",
        "link_url": "/user/ui/",
        "title": "Vaše heslo bylo změněno"
      },
      "resetPW": {
        "title": "Reset your password"
      },
      "security": {
        "2fa": {
          "availableMethods": "Dostupné metody 2FA:",
          "info": "Dvoufaktorové ověřování (2FA) je bezpečnostní funkce, která přidává k vašemu účtu další vrstvu ochrany. Vyžaduje použití dvou metod pro přihlášení, nikoli pouze uživatelského jména a hesla.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Nechte si e-mailem zaslat jednorázové kódy pro dokončení požadavků na ověřování.",
            "oath": {
              "add": {
                "button": "Registrovat aplikaci Authenticator"
              }
            }
          }
        },
        "authenticator": "Aplikace Authenticator",
        "infoFederatedAccount": "Tento účet je spravován poskytovatelem identity vaší organizace, takže heslo zde nelze změnit. Chcete-li změnit heslo, přihlaste se prostřednictvím přihlašovací stránky vaší organizace nebo kontaktujte svého IT administrátora.",
        "lastUse": "Naposledy použito v {0}.",
        "msg": {
          "invalidPassword": "Zadáno neplatné aktuální heslo.",
          "passwordAlreadyUsed": "Nelze znovu použít posledních 5 hesel.",
          "pwUpdateError": "Došlo k chybě při pokus o změnu hesla.",
          "pwUpdated": "Heslo bylo změněno."
        },
        "noDevice": "Není nakonfigurováno",
        "oathAdd": {
          "appInfo": "Pro usnadnění procesu přihlášení do STIHL můžete použít aplikace Authenticator, jako jsou {0}, {1}, {2} atd., k vygenerování jednorázového hesla, které se používá jako druhý faktor během procesu přihlášení.<br/>Pokud jste ztratili nebo zapomněli své mobilní zařízení, můžete kdykoli použít kód 2FA zaslaný e-mailem.<br/><br/>Postupujte podle níže uvedených pokynů k nastavení ověřovacího zařízení.",
          "badCode": "Neplatný kód, zkuste to prosím znovu.",
          "error": "Při pokusu o registraci ověřovacího zařízení došlo k chybě.",
          "headScan": "1. Naskenujte QR kód pomocí ověřovací aplikace",
          "headVerify": "2. Ověřte kód",
          "infoKey": "instalační klíč",
          "infoKeyTitle": "Váš dvoufaktorový tajný kód",
          "infoScanBottom": "Nelze skenovat? Můžete použít {0} pro ruční konfiguraci vaší ověřovací aplikace.",
          "infoVerify": "Zadejte kód vygenerovaný vaší ověřovací aplikací.",
          "success": "Vaše ověřovací zařízení bylo zaregistrováno. Nyní jej můžete použít k přihlášení.",
          "title": "Zaregistrujte své zařízení s dvoufaktorovým ověřováním"
        },
        "oathDelete": {
          "error": "Při pokusu o smazání ověřovacího zařízení došlo k chybě.",
          "success": "Ověřovací zařízení bylo smazáno."
        },
        "passkeys": {
          "about": {
            "info1": "Přístupové klíče jsou dvojice kryptografických klíčů (veřejný klíč a soukromý klíč), které ukládá ověřovatel, kterého ovládáte. Ověřovatel může prokázat, že je uživatel přítomen a je oprávněn používat přístupový klíč. Ověřovatelé prokazují autorizaci pomocí PINu, přístupového kódu, biometrických údajů nebo hesla zařízení v závislosti na možnostech a konfiguraci ověřovatele. Ověřovatelé se dodávají v mnoha podobách, například jako zařízení iPhone nebo Android, Windows Hello, hardwarový bezpečnostní klíč FIDO2 nebo správce hesel.",
            "info2": "Když se přihlásíte do STIHL pomocí přístupového klíče, váš ověřovatel použije kryptografii veřejného klíče k ověření vaší identity společnosti STIHL, aniž by přístupový klíč odeslal. Přístupové klíče jsou vázány na doménu webových stránek, například stihl-sso.com, a vyžadují zabezpečené připojení, což znamená, že webový prohlížeč odmítne ověřit se na podobném phishingovém webu. Díky těmto vlastnostem jsou přístupové klíče vysoce odolné vůči phishingu a mnohem hůře se na ně lze obrátit než na SMS nebo TOTP 2FA, které lze…“ phished.",
            "info3": "Cloudové služby pro správu hesel umožňují synchronizaci hesel napříč zařízeními (například zařízeními Apple, zařízeními Android nebo správci hesel), takže je lze používat z více míst a méně snadno se ztrácejí. Jakmile nastavíte synchronizované heslo na jednom zařízení, je toto heslo k dispozici pro použití na více zařízeních používajících stejnou službu. Pokud si například zaregistrujete heslo k účtu iCloud pomocí Touch ID na MacBooku, můžete toto heslo používat s obličejem, otiskem prstu, PINem nebo heslem zařízení zaměnitelně na více zařízeních propojených se stejným účtem iCloud.",
            "title": "O heslech"
          },
          "add": {
            "button": "Přidat nové heslo",
            "error": "Při pokusu o přidání nového hesla došlo k chybě.",
            "success": "Bylo přidáno nové heslo."
          },
          "delete": {
            "button": "Smazat přístupový klíč",
            "error": "Při pokusu o smazání tohoto přístupového klíče došlo k chybě.",
            "success": "Přístupový klíč byl smazán."
          },
          "edit": {
            "error": "Při pokusu o uložení názvu přístupového klíče došlo k chybě.",
            "name": "Název přístupového klíče",
            "success": "Název přístupového klíče byl aktualizován.",
            "title": "Zadejte název svého přístupového klíče, abyste jej odlišili od ostatních přístupových klíčů"
          },
          "info": "Přístupový klíč je jednoduchá a bezpečná alternativa k heslům, která ověřuje vaši identitu pomocí dotyku, rozpoznávání obličeje, hesla zařízení nebo PINu.",
          "none": "Není nakonfigurován žádný přístupový klíč.",
          "reallyDelete": "Jste si jisti, že chcete smazat přístupový klíč?",
          "registeredPasskeys": "Vaše registrované přístupové klíče:",
          "title": "Přístupové klíče"
        },
        "reallyDeleteDevice": "Jste si jisti, že chcete smazat ověřovací zařízení?",
        "secMFA": "Dvoufaktorové ověřování",
        "secPwdChange": "Změnit heslo",
        "title": "Zabezpečení"
      },
      "setPW": {
        "acceptTC": "Please confirm our {terms} and read our {privacy}.",
        "killSSO": "Zrušení platnosti všech aktivních relací",
        "msg": {
          "tokenExpired": "The password link or code expired. Please follow the link to reset your password: {link}."
        },
        "privacy": "Data Privacy Policy",
        "terms": "Terms and Conditions",
        "title": "Zadejte nové heslo"
      }
    },
    "validations": {
      "hasDigit": "Musí obsahovat číslici",
      "hasLowercase": "Musí obsahovat malá písmena",
      "hasSpecial": "Musí obsahovat speciální znak: {chars}",
      "hasUppercase": "Musí obsahovat velká písmena",
      "invalidCharacters": "Obsahuje neplatné znaky",
      "maxLength": "Maximální {max} znaků",
      "minLength": "Minimálně {min} znaků",
      "notSameAsEmail": "Příliš podobné e-mailové adrese",
      "onlyValidCharactersAllowed": "Povolena jsou pouze písmena, číslice a mezery.",
      "required": "Požadovaná hodnota",
      "sameAsPassword": "Hesla se neshodují",
      "tcAccepted": "Please confirm our terms and conditions.",
      "validEmail": "Invalid email address.",
      "validOTP": "Please enter the verification code."
    }
  }
}
